import { render, staticRenderFns } from "./CadastroRequisitoItem.vue?vue&type=template&id=efd6b77e&scoped=true&lang=pug&"
import script from "./CadastroRequisitoItem.vue?vue&type=script&lang=js&"
export * from "./CadastroRequisitoItem.vue?vue&type=script&lang=js&"
import style0 from "./CadastroRequisitoItem.vue?vue&type=style&index=0&id=efd6b77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd6b77e",
  null
  
)

export default component.exports